import React from 'react'

const Input = (props) => {
  return (
    <input type={props.type} placeholder={props.placeholder} onChange={props.onChange} value={props.value} className={props.className} id={props.id} style={{border: '1px solid #FFDBB0'}} name={props.name} maxLength={props.maxlength}/>
  )
}

export default Input